import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import Text from 'components/Formik/Text';
import Button from 'components/Button';
import Checkboxes from 'components/Formik/Checkboxes';
import TextArea from 'components/Formik/TextArea';
import Select from 'components/Formik/Select';
import Radios from 'components/Formik/Radios';

const initialValues = {
	FirstName: '',
	LastName: '',
	Email: '',
	products: [],
	subscribe: '',
	country: '',
	comments: '',
};

const validationSchema = Yup.object({
	FirstName: Yup.string().required('Required'),
	LastName: Yup.string().required('Required'),
	Email: Yup.string().email('Must be a valid email address').required('Required'),
	products: Yup.array().min(1, 'Required'),
	country: Yup.string().required('Required'),
	comments: Yup.string().required('Required'),
	subscribe: Yup.string().required('Required'),
});

const Form18034 = ({ handleSubmit, isPending }) => {
	return (
		<Formik
			initialValues={initialValues}
			onSubmit={values => handleSubmit('marketo', values)}
			validationSchema={validationSchema}
		>
			{formik => (
				<Form className='form form--lg'>
					<Text label='First Name' name='FirstName' type='text' />
					<Text label='Last Name' name='LastName' type='text' />
					<Text label='Email Address' name='Email' type='email' />
					<h4>Products</h4>
					<Checkboxes
						options={[
							{ value: 'HemoSphere', label: 'HemoSphere' },
							{ value: 'Sapien 3', label: 'Sapien 3' },
							{ value: 'FloTrac', label: 'FloTrac' },
						]}
						label='Products'
						name='products'
					/>
					{formik.values.products.includes('HemoSphere') && <h2>HemoSphere was chosen</h2>}
					<Select
						label='Country'
						name='country'
						placeholder='Select a Country'
						options={[
							{ value: 'US', label: 'United States' },
							{ value: 'JP', label: 'Japan' },
							{ value: 'EU', label: 'Europe' },
						]}
					/>
					{formik.values.country.includes('US') && <p>You chose United States</p>}
					<TextArea label='comments' name='comments' />
					<Radios
						options={[
							{
								label: 'Choice 1',
								value: '1',
							},
							{
								label: 'Choice 2',
								value: '2',
							},
						]}
						name='subscribe'
					/>
					<Button type='submit' size='lg' disabled={isPending}>
						{!isPending ? 'Submit' : 'Submitting...'}
					</Button>
				</Form>
			)}
		</Formik>
	);
};

export default Form18034;
